import { Component } from '@angular/core';

@Component({
  standalone: false,
  selector: 'suvo-bi-tour-window',
  templateUrl: './tour-window.component.html',
  styleUrls: ['./tour-window.component.scss'],
})
export class TourWindowComponent {}
